/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getMedReps = (date) => makeApiCall(`/cwp/manager/reps`, 'POST', { date });
export const getMedRepsApproved = (params) =>
  makeApiCall(`/cwp/approved/manager/reps`, 'POST', params);

export const getAppointments = (params) => makeApiCall(`/cwp/list`, 'POST', params);
export const postApprovalApproved = (params) => makeApiCall(`/cwp/approved`, 'POST', params);
export const postApprovalRejected = (params) => makeApiCall(`/cwp/reject`, 'POST', params);

export const getAppointmentStat = (params) => makeApiCall(`/cwp/appointment-stat`, 'POST', params);

export const getBelowTarget = (params) =>
  makeApiCall(`/cwp/below-targets`, 'POST', { cwp: params });

export const getJustified = (params) => makeApiCall(`/cwp/justified`, 'POST', params);

export const getJustifiedExport = (params) => makeApiCall(`/cwp/justified/export`, 'POST', params);
